import { Link } from 'react-router-dom';
import { MapPin, Mail, ExternalLink } from 'lucide-react';
import { Separator } from '@/components/ui/separator';

const navLinks = [
  { href: '/', label: 'Startseite' },
  { href: '/sportangebote', label: 'Sportangebote' },
  { href: '/vereinsleben', label: 'Vereinsleben' },
  { href: '/ueber-uns', label: 'Über uns' },
  { href: '/kontakt', label: 'Kontakt' },
];

const sportLinks = [
  { href: '/sportangebote', label: 'Fußball' },
  { href: '/sportangebote', label: 'Fitness & Turnen' },
  { href: '/sportangebote', label: 'Tischtennis' },
  { href: '/sportangebote', label: 'Volleyball' },
  { href: '/sportangebote', label: 'Badminton' },
  { href: '/sportangebote', label: 'Kinderturnen' },
];

export default function Footer() {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-10 h-10 bg-[#F5C200] rounded-xl flex items-center justify-center font-bold text-[#1a1a1a] text-sm font-['Space_Grotesk']">
                HSC
              </div>
              <div>
                <div className="font-semibold text-white text-base">HSC Alswede von 1946 e.V.</div>
                <div className="text-xs text-gray-400">Sportverein Lübbecke-Alswede</div>
              </div>
            </div>
            <p className="text-sm text-gray-400 leading-relaxed max-w-xs">
              Dein Sportverein in Alswede. Seit 1946 vereinen wir Menschen durch Sport, 
              Gemeinschaft und Freude an der Bewegung. Über 450 Mitglieder – 
              werde Teil unserer Familie.
            </p>
            <div className="mt-4 space-y-2">
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <MapPin className="w-4 h-4 text-[#F5C200] flex-shrink-0" />
                <span>Schanzeweg 7, 32312 Lübbecke (Alswede)</span>
              </div>
              <div className="flex items-center gap-2 text-sm text-gray-400">
                <Mail className="w-4 h-4 text-[#F5C200] flex-shrink-0" />
                <span>patrick.bruels@hsc-alswede.de</span>
              </div>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">Navigation</h3>
            <ul className="space-y-2">
              {navLinks.map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-400 hover:text-[#F5C200] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Sports */}
          <div>
            <h3 className="font-semibold text-white text-sm mb-4 uppercase tracking-wider">Sportangebote</h3>
            <ul className="space-y-2">
              {sportLinks.map((link, i) => (
                <li key={i}>
                  <Link
                    to={link.href}
                    className="text-sm text-gray-400 hover:text-[#F5C200] transition-colors"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <Separator className="my-8 bg-white/10" />

        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 text-xs text-gray-500">
          <div>© {new Date().getFullYear()} HSC Alswede von 1946 e.V. – Alle Rechte vorbehalten</div>
          <div className="flex items-center gap-4">
            <span>Sportverein Lübbecke · Sportverein Alswede</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
